import { TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const DEBOUNCE_DELAY = 500; // milliseconds

type TextFilterProps = {
  field: string;
  label: string;
  value: string;
  onChange: (field: string, value: string) => void;
};

export function TextFilter({ field, label, value, onChange }: TextFilterProps) {
  const [localValue, setLocalValue] = useState(value);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (newValue: string) => {
    setLocalValue(newValue);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onChange(field, newValue);
    }, DEBOUNCE_DELAY);
    return () => clearTimeout(timerRef.current);
  };

  return (
    <TextField
      size="small"
      label={label}
      value={localValue}
      onChange={(e) => handleChange(e.target.value)}
      sx={{ minWidth: 180 }}
    />
  );
}
